var faqs = [
    //EDIT START
    {q: `What is a Miimu?`,
         a: `A Miimu is a smart link that captures content from virtually any online source. Save web pages, Instagram posts, YouTube videos, Google docs and so much more.`},
         
    {q: `Why should I use miimu.com?`, 
        a: `Miimu captures and organizes content you care about. Use it for personal reasons, work or school — or any aspect of your online life! Check out some use cases for more examples of the magic of miimu.com on our Youtube channel or social accounts.`},


 {q: `Is there a limit to how many Miimus I can make?`,
         a: `A Miimu profile supports unlimited Miimu links and bundles, so you'll never run out of room. Explore Miimu plans to score endless options.`},


  {q: `What does the rating system mean for Miimu?`, 
        a: `Users can assign a rating scale for their Miimus, to display them by order of importance. The scale ranges from one to five. This system work well in collab bundles.`},


{q: `How do I delete a Miimu?`, 
        a: `RIP to that Miimu. Select the three-dot icon inside the Miimu you want to remove and click 'Delete.'`},


{q: `How do I delete a Bundle?`, 
        a: `RIP to that Bundle too. Select the three-dot icon inside the Bundle you want to remove. Navigate to the 'Edit Bundle' option with wrench icon and click 'Delete.'`},


{q: `Can I customize My Bundles page?`, 
        a: `You can adjust your Bundle dashboard according to your workflow. Click the eyeball icon to select single or multi-Bundle views, notes, ratings and more.`},


{q: `Can I edit my profile?`, 
        a: `You can customize your photo and description on your profile by clicking the pencil icon next to your handle.`},


{q: `Can I block ads?`, 
        a: `Yes, thank goodness. To hide in-bundle ads, select Hide Ads from the drop-down eyeball menu. Please note that ad blocking is a Premium feature, so upgrade your profile to banish those pesky ads once and for all.`},


{q: `What are miimu.com's security policies?`, 
        a: `We believe everyone should have access to your data. Jk! We use Amazon Web Services and follow its best practices for privacy.`},


{q: `How do I delete my account?`, 
        a: `We'd hate to see you go. To delete your account, visit Account Settings and follow the steps under the "Delete Account" section.`},


{q: `Can I receive notifications from my Miimu app??`, 
        a: `Yes, users receive alerts through the notification zone. Enhanced text and email notifications are coming soon.`},


{q: `Will Miimu send me email notifications?`, 
        a: `Eventually. We know that emails are the backbone of Internet communication, so email notifications are coming soon.`},




{q: `Does miimu.com work offline?`, 
        a: `Eventually. We know that emails are the backbone of Internet communication, so email notifications are coming soon.`},




{q: `Can I send Bundles to non-miimu.com users?`, 
        a: `Absolutely! Miimu links and Bundles can be shared or viewed outside of the Miimu interface, but only registered Miimu users can import them to their own accounts. Sign up for Miimu to become one of the cool kids and do just that`},


{q: `Can I add users to my miimu.com account?`, 
        a: `At this time, Miimu is available for single users only. Business plans will be available in a future release phase.`},


{q: `Where do I find other miimu.com users?`, 
        a: `To find your friends on Miimu, enter their preferred email address through the Collab Network. Click the person icon in the header menu to find this section.`},


{q: `Can I download a Bundle?`, 
        a: `Miimu is an exclusively web-based service. While Bundles are sharable — and other Miimu users can import Bundles — there is no option to download Bundles at this time.`},


{q: `Something isn't loading in my profile. WTF?`, 
        a: `We're always working to improve miimu.com. Try clicking 'Refresh' in your Bundle menu. Otherwise contact support at help@miimu.com.`},




{q: `What is the miimu.com privacy policy?`, 
        a: `We strive to maintain industry standards regarding your privacy. Consult our Privacy Policy page for more information.`},


{q: `How can I contact support?`, 
        a: `We strive to maintain industry standards regarding your privacy. Consult our Privacy Policy page for more information.`},


    //EDIT END
]


module.exports = faqs
